<template>
	<div class="my">
		<div class="tab-item">
			<div class="user-info">
				<img src="../assets/images/user-pic.png" alt="" class="user-pic">
				<div class="user-status">
					<div class="login-status" v-if="!loginPhone">您还未登录</div>
					<div class="user-name" v-else>{{nickname}}</div>
					<div class="login" v-if="!loginPhone" @click="login">
						<div class="login-text">立即登录</div>
						<img src="../assets/images/login-more.png" alt="" class="login-more">
					</div>
					<div class="user-data" v-else @click="editor">
						<div class="data-text">编辑资料</div>
						<img src="../assets/images/data-more.png" alt="" class="data-more">
					</div>
				</div>
			</div>
		</div>
		<div class="tab-item">
			<div class="equipment-info">
				<div class="equipment-msg">
					<img src="../assets/images/watch.png" alt="" class="watch">
					<div class="equipment-status">
						<div class="equipment-name" v-if="!equipment">我的设备</div>
						<div class="equipment-point" v-if="!equipment">绑定设备后才可进行情绪识别</div>
						<div class="equipment-name" v-if="equipment">彼馨L18</div>
						<div class="equipment-point" v-if="equipment">{{watchT}}:{{imei}}</div>
					</div>
				</div>
				<div class="equipment" v-if="!equipment" @click="bindEquipment">绑定设备</div>
				<div class="equipment" v-if="equipment" @click="checkEquipment">管理设备</div>
			</div>
		</div>
		<div class="my-tab" @click="report">
			<div class="tab-name">情绪报告</div>
			<img src="../assets/images/report.png" alt="" class="tab-pic">
		</div>
		<div class="my-tab" @click="serviceRecord">
			<div class="tab-name">服务记录</div>
			<img src="../assets/images/server.png" alt="" class="tab-pic">
		</div>
		<div class="my-tab" @click="health">
			<div class="tab-name">生理健康</div>
			<img src="../assets/images/health.png" alt="" class="tab-pic">
		</div>
		<div class="my-tab" @click="whiteList">
			<div class="tab-name">通讯白名单</div>
			<img src="../assets/images/white-list.png" alt="" class="tab-pic">
		</div>
		<div class="my-tab" @click="secretary">
			<div class="tab-name">情绪小秘书</div>
			<img src="../assets/images/secretary.png" alt="" class="tab-pic">
			<div v-if="$store.state.secretarylength>0" class="info-dot"></div>
		</div>
		<div class="my-tab" @click="todatemo">
			<div class="tab-name">情绪日记</div>
			<img src="../assets/images/emodate.png" alt="" class="tab-pic">
			<div v-if="$store.state.emodate>0" class="info-dot"></div>
		</div>
		<div class="out" v-if="loginPhone" @click="modal=true">退出登录</div>
		<div class="feedback" @click="feedback">
			<div class="feedback-text">问题反馈</div>
			<img src="../assets/images/feedback.png" alt="" class="feedback-more">
		</div>
		<Tab name="my"></Tab>
		<div class="unbind-modal" v-show="modal">
			<div class="unbind">
				<div class="unbind-title">退出登录</div>
				<div class="unbind-content">退出登录后部分功能将无法使用，是否退出？</div>
				<div class="btns">
					<div class="cancel" @click="modal=false">取消</div>
					<div class="sure" @click="out">确定</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import wx from "weixin-js-sdk";
	import Tab from '../components/bot-tab.vue'
	import {
		user_info
	} from '../api/my'
	export default {
		components: {
			Tab,
		},
		data() {
			return {
				watchT:"IMEI",
				loginPhone: false,
				equipment: false,
				nickname: '',
				imei: '',
				modal: false,
			};
		},
		computed: {},
		methods: {
			todatemo() {
				this.$router.push({
					path: '/secretary',
					query: {
						type: 'datemotion'
					}
				})
			},
			secretary() {
				// this.$router.push('/secretary')
				this.$router.push({
					path: '/secretary',
					query: {
						type: 'secretary'
					}
				})
			},
			feedback() {
				this.$router.push('/feedback')
			},
			whiteList() {
				this.$router.push('/whiteList')
			},
			login() {
				this.$router.push('/login')
			},
			checkEquipment() {
				if(this.imei.length>16){
					let phone = localStorage.getItem('phone')
					return wx.miniProgram.navigateTo({url: '/pages/mywatch/mywatch?phone='+phone})
				}
				this.$router.push('/unbind-equipment')
			},
			bindEquipment() {
				if (this.loginPhone) {
					this.$router.push('/bind-equipment')
					// this.$router.push('/selectequipment')
				} else {
					this.$toast('请先进行登录');
					sessionStorage.setItem('router', '/my')
					this.login()
				}
			},
			editor() {
				this.$router.push('/editor-user')
			},
			out() {
				localStorage.removeItem('phone')
				//localStorage.removeItem('imei')
				this.$router.push('/login')
			},
			report() {
				let phone = localStorage.getItem('phone')
				let imei = localStorage.getItem('imei')
				if (phone) {
					if (!imei) {
						this.$router.push('/bind-equipment')
						// this.$router.push('/selectequipment')
					} else {
						this.$router.push('/report')
					}
				} else {
					this.$router.push('/login')
				}
			},
			serviceRecord() {
				let phone = localStorage.getItem('phone')
				let imei = localStorage.getItem('imei')
				if (phone) {
					if (!imei) {
						this.$router.push('/bind-equipment')
						// this.$router.push('/selectequipment')
					} else {
						this.$router.push('/service-record')
					}
				} else {
					this.$router.push('/login')
				}
			},
			health() {
				let phone = localStorage.getItem('phone')
				let imei = localStorage.getItem('imei')
				if (phone) {
					if (!imei) {
						this.$router.push('/bind-equipment')
						// this.$router.push('/selectequipment')
					} else {
						this.$router.push('/health')
					}
				} else {
					this.$router.push('/login')
				}
			},
			userinfo() {
				user_info(this.loginPhone).then(res => {
					if (res.status == 200) {
						if (res.data.userinfo.nickname) {
							this.nickname = res.data.userinfo.nickname;
							localStorage.setItem('nickname',res.data.userinfo.nickname)
						}
						if (res.data.userinfo.imei != '') {
							this.imei = res.data.userinfo.imei;
							if(this.imei.length>16){
								this.watchT = "MAC"
							}
							this.equipment = true;
							localStorage.setItem('imei',this.imei)
						}else{
							localStorage.removeItem('imei')
						}
					}
				})
			}
		},
		created() {
			let phone = localStorage.getItem('phone')
			this.loginPhone = phone
			if (phone) {
				this.userinfo()
			}
		},
	};
</script>
<style lang='less' scoped>
	.my {
		padding: 16px;
		padding-bottom: 70px;
	}
	.tab-item {
		background-color: #fff;
		border-radius: 10px;
		padding: 12px;
		margin-bottom: 10px;
	}

	.info-dot {
		width: 6px;
		height: 6px;
		background-color: red;
		position: absolute;
		top: 20px;
		right: 30px;
		border-radius: 50%;
	}

	.user-info {
		display: flex;
		justify-content: flex-start;
	}

	.user-pic {
		display: block;
		height: 56px;
		width: 56px;
		margin-right: 12px;
	}

	.login-status,
	.user-name {
		padding-top: 6px;
		height: 20px;
		line-height: 20px;
		font-weight: 700;
		font-size: 20px;
		color: #0F0F0F;
		padding-bottom: 10px;
	}

	.login,
	.user-data {
		display: flex;
		justify-content: flex-start;
	}

	.login-text {
		height: 14px;
		line-height: 14px;
		margin-right: 3px;
		font-size: 14px;
		font-weight: 500;
		color: #01D6D6;
	}

	.login-more {
		display: block;
		height: 14px;
	}

	.data-text {
		height: 14px;
		line-height: 14px;
		margin-right: 3px;
		font-size: 14px;
		font-weight: 500;
		color: #999999;
	}

	.data-more {
		display: block;
		height: 14px;
	}

	.equipment-info {
		display: flex;
		justify-content: space-between;
	}

	.equipment-msg {
		display: flex;
		justify-content: flex-start;
	}

	.watch {
		display: block;
		height: 40px;
		width: 40px;
		margin-right: 10px;
	}

	.equipment-name {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		font-weight: 500;
		color: #333;
	}

	.equipment-point {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		font-weight: 500;
		color: #999;
	}

	.equipment {
		margin-top: 5px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background-color: #01D6D6;
		color: #fff;
		font-size: 12px;
		font-weight: 500;
		border-radius: 15px;
		padding: 0px 15px;
	}

	.my-tab {
		background-color: #fff;
		border-radius: 10px;
		padding: 12px;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		position: relative;
	}

	.tab-name {
		height: 46px;
		line-height: 46px;
		font-size: 14px;
		color: #333;
		font-weight: 500;
	}

	.tab-pic {
		display: block;
		height: 24px;
		width: 24px;
		margin-top: 11px;
	}

	.out {
		height: 50px;
		line-height: 50px;
		text-align: center;
		background-color: #fff;
		border-radius: 10px;
		color: #333;
		font-size: 14px;
		font-weight: 500;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.feedback {
		height: 14px;
		display: flex;
		justify-content: center;
	}

	.feedback-text {
		height: 16px;
		line-height: 16px;
		font-size: 14px;
		color: #999;
	}

	.feedback-more {
		display: block;
		height: 16px;
	}

	.unbind-modal {
		position: fixed;
		left: 0px;
		top: 0px;
		background-color: rgba(0, 0, 0, 0.2);
		z-index: 10;
		width: 100%;
		height: 100%;
	}

	.unbind {
		width: 210px;
		padding: 30px;
		background-color: #fff;
		border-radius: 10px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.unbind-title {
		height: 20px;
		line-height: 20px;
		font-size: 20px;
		font-weight: 500;
		color: #333;
		margin-bottom: 30px;
		text-align: center;
	}

	.unbind-content {
		line-height: 20px;
		font-size: 14px;
		color: #333;
		margin-bottom: 30px;
		text-align: center;
	}

	.btns {
		height: 48px;
		display: flex;
		justify-content: space-between;
	}

	.cancel {
		height: 48px;
		width: 48%;
		border-radius: 24px;
		line-height: 48px;
		text-align: center;
		background-color: #F2F6F6;
		font-size: 16px;
		font-weight: 500;
		color: #333;
	}

	.sure {
		height: 48px;
		width: 48%;
		border-radius: 24px;
		line-height: 48px;
		text-align: center;
		background-color: #01D6D6;
		font-size: 16px;
		font-weight: 500;
		color: #fff;
	}
</style>
